import { ref } from 'vue';
import { defineStore } from 'pinia';
import { adminEventRuntimeApiSdk } from '../sdk/adminEventRuntimeApiSdk';

export const useAdminSdkStatusStore = defineStore('adminSdkStatusStore', () => {
    /**
     * Start changefeed data
     */
    const changeFeeds = ref({});
    function updateChangeFeedInfo(changeFeedName, newInfo) {
        changeFeeds.value[changeFeedName] = {
            ...changeFeeds.value[changeFeedName],
            ...newInfo,
        };
    }

    function getChangeFeedInfo(changeFeedName) {
        return changeFeeds.value[changeFeedName];
    }

    /**
     * Stop changefeed data
     * Start Engine system status data
     */
    const engineSystemStatusIntervalId = ref();
    const hasEngineMismatch = ref(false);
    const eventMismatches = ref([]);
    const itemMismatches = ref([]);
    async function refreshEngineSystemStatus() {
        if (adminEventRuntimeApiSdk.baseBiddingUri) {
            try {
                const response = await adminEventRuntimeApiSdk.getEngineSystemStatus();
                hasEngineMismatch.value = response.matchesFound;
                if (response.matchesFound) {
                    eventMismatches.value = response.testMatches.events;
                    itemMismatches.value = response.testMatches.items;
                } else {
                    eventMismatches.value = [];
                    itemMismatches.value = [];
                }
            } catch (err) {
                console.log(`Error getting engine system status: ${err.message}`);
                console.error(err);
            }
        }
    }

    async function startEngineSystemStatusPoll() {
        await refreshEngineSystemStatus();
        if (engineSystemStatusIntervalId.value) { return } else {
            engineSystemStatusIntervalId.value = setInterval(async function () {
                try {
                    await refreshEngineSystemStatus();
                } catch (err) {
                    console.error(err);
                }
            }, 15000)
        }
    }

    async function stopEngineSystemStatusPoll() {
        if (engineSystemStatusIntervalId.value) {
            clearInterval(engineSystemStatusIntervalId.value);
            engineSystemStatusIntervalId.value = 0; // falsy which works well. 
        }
    }

    /**
     * Stop Engine system status data
     */

    return {
        changeFeeds,
        updateChangeFeedInfo,
        getChangeFeedInfo,
        startEngineSystemStatusPoll,
        refreshEngineSystemStatus,
        stopEngineSystemStatusPoll,
        hasEngineMismatch,
        eventMismatches,
        itemMismatches
    }
})

/*
changeFeeds {
    'admin-event-activity': {
        title: 'Event Activity',
        description: 'Real-time event lifecycle and state transitions',
        status: 'RECONNECTING', //INITIALIZING, CONNECTED, DISCONNECTED
        attempt: 4
    },
    'admin-item-bidding': {
        title: 'Item Bidding',
        description: 'Live bid stream and item auction state',
        status: 'CONNECTED',
        attempt: 4
    }
}
*/